// @flow
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

import { fetchPatientData } from './patientActions';

export const ADD_UPDATE_LOADING = 'ADD_UPDATE_LOADING';
export const ADD_UPDATE_SUCCESS = 'ADD_UPDATE_SUCCESS';
export const ADD_UPDATE_ERROR = 'ADD_UPDATE_ERROR';
export const UPDATE_UPDATE_LOADING = 'UPDATE_UPDATE_LOADING';
export const UPDATE_UPDATE_SUCCESS = 'UPDATE_UPDATE_SUCCESS';
export const UPDATE_UPDATE_ERROR = 'UPDATE_UPDATE_ERROR';
export const DELETE_UPDATE_LOADING = 'DELETE_UPDATE_LOADING';
export const DELETE_UPDATE_SUCCESS = 'DELETE_UPDATE_SUCCESS';
export const DELETE_UPDATE_ERROR = 'DELETE_UPDATE_ERROR';

export function addUpdate(patientId: string, update: Object) {
  const body = {
    task: update.task,
    description: update.description,
    dateDue: update.dateDue || new Date(),
    dateCompleted: update.dateCompleted,
    patientId,
  };
  return ((dispatch: Function) => {
    dispatch({
      type: ADD_UPDATE_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/update/addUpdate`,
      body,
      (data) => {
        dispatch({
          type: ADD_UPDATE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_UPDATE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function deleteUpdate(patientId: string, updateId: string) {
  const body = {
    patientId,
    updateId,
  };
  return ((dispatch: Function) => {
    dispatch({
      type: DELETE_UPDATE_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/update/deleteUpdate`,
      body,
      (data) => {
        dispatch({
          type: DELETE_UPDATE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_UPDATE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function updateUpdate(patientId: string, update: Object) {
  const body = {
    task: update.task,
    description: update.description,
    dateDue: update.dateDue || new Date(),
    dateCompleted: update.dateCompleted,
    patientId,
    updateId: update.updateId,
  };
  return ((dispatch: Function) => {
    dispatch({
      type: UPDATE_UPDATE_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/update/updateUpdate`,
      body,
      (data) => {
        dispatch({
          type: UPDATE_UPDATE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_UPDATE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function setUpdateArchived(patientId: string, updateId: string,
                                  archive: boolean) {
  const body = {
    patientId,
    updateId,
    archive,
  };
  return ((dispatch: Function) => {
    dispatch({
      type: UPDATE_UPDATE_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/update/setUpdateArchived`,
      body,
      (data) => {
        dispatch({
          type: UPDATE_UPDATE_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_UPDATE_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/updateActions.js